export default __webpack_public_path__ + "static/share-image-9e79b597ffa974e6abd5af3b1c8221cc.png";